
import couponManualAdd from './../component/couponManualAdd.vue'
import couponView from './component/coupon/couponView.vue'
import couponUser from './component/coupon/couponUser.vue'
export default {
  className: 'couponActivity',
  title: '手动发放优惠券',
  render: (record) => {
    let stringFields = ['name']
    return stringFields.map(f => record[f]).join('-')
  },
  fields: [
    {
      name: 'name'
    },
    {
      name: 'details',
      note: '商品代金券详情',
      listWhere: (where) => {
        where.couponType = 'shopping'
        where.isDel = {
          $ne: true
        }
      }
    },
    {
      name: 'type',
      note: '发放类型'
    },
    {
      name: 'day',
      note: '商品代金券有效期',
      validators: [
        (val) => /^[1-9]\d*$/.test(val) ? null : '请填写正确的商品代金券有效期'
      ]
    }
  ],
  search: [
    'name',
    'day'
  ],
  action: {
    create: {
      component: couponManualAdd
    },
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      component: couponView
    },
    viewUser: {
      type: 'row',
      text: '参与用户',
      component: couponUser
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'manual'
    },
    beforeInsert ({ data }) {
      data.type = 'manual'
    }
  }
}
